var map = {
	"./bg.jpg": "f2c8",
	"./login-bg.jpg": "64ac",
	"./logisticsDelivery/quotation.jpg": "9e6ad",
	"./tj.jpg": "fab6",
	"./touxiang.jpg": "ab45",
	"./yrf.jpg": "6edc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9853";